import EmailTemplatesModal from './components/email-templates-modal';
import EmailTemplateFormModal from './components/email-template-form-modal';
import PropTypes from 'prop-types';
import { useOpenClose } from '@evertrue/sdk';

const EmailTemplatesModalController = ({ closeModal, contact, setFieldValue, emailBody, refreshInlineImageUrls }) => {
  const [isTemplateFormOpen, openTemplateForm, closeTemplateForm] = useOpenClose(false);

  return (
    <>
      {!isTemplateFormOpen && (
        <EmailTemplatesModal
          closeModal={closeModal}
          contact={contact}
          setFieldValue={setFieldValue}
          openTemplateForm={openTemplateForm}
          emailBody={emailBody}
          refreshInlineImageUrls={refreshInlineImageUrls}
        />
      )}
      {isTemplateFormOpen && <EmailTemplateFormModal closeTemplateForm={closeTemplateForm} />}
    </>
  );
};

EmailTemplatesModalController.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.object,
  setFieldValue: PropTypes.func, //from the email form to update the email body
  emailBody: PropTypes.string,
  refreshInlineImageUrls: PropTypes.func,
};

export default EmailTemplatesModalController;
